<template>

<fragment>

<core-dropdown-level v-if="is.family" parent="tag.add" name="family" v-on:level="onFamilyClick(false)" class="family">

	<template v-for="item in familyTags">

		<core-dropdown-item :key="item.id" type="tagToggle" :loading="tagging === item.id" :color="item.colour" :fore="item.fore" v-on:add="onTagAdd(item)" v-on:remove="onTagRemove(item)">{{ item.text }}</core-dropdown-item>

	</template>

</core-dropdown-level>

<core-dropdown-level v-if="can.tag && !is.family" name="tag.add" :level="level">

	<template v-for="item in items">

		<core-dropdown-item :key="item.id" type="level" level="family" :color="item.colour" v-on:level="onFamilyClick(item.id)" v-if="item.isFamily">{{ item.name }}</core-dropdown-item>
		<core-dropdown-item :key="item.id" type="tagToggle" :loading="tagging === item.id" :color="item.colour" :fore="item.fore" v-on:add="onTagAdd(item)" v-on:remove="onTagRemove(item)" v-if="item.isTag">{{ item.text }}</core-dropdown-item>

	</template>

</core-dropdown-level>

</fragment>

</template>

<script>

export default {

	props: ['filter', 'item', 'level', 'tagging'],

	data: function() {

		return {

			is: {
				loading: false,
				family: false
			}

		}

	},

	computed: {

		contextTitle: function() {

			return this.$CONSTANTS.SERVICE.TITLE[this.$store.getters['service/select/name']] + ' tags'

		},

		tags: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return !tag.family

			})

		},

		families: function() {

			return this.$store.getters['data/tagFamilies/list']

		},

		items: function() {

			var items = []

			this.$_.each(this.tags, function(tag) {

				tag = this.$util.copy(tag)
				tag.sort = tag.text
				tag.isTag = true

				items.push(tag)

			}.bind(this))

			this.$_.each(this.families, function(family) {

				var tags = this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

					return tag.family === family.id && !this.$_.contains(this.$store.getters['filter/collection/tags/absolute'], tag.id)

				}.bind(this))

				if (tags.length) {

					family = this.$util.copy(family)
					family.sort = family.name
					family.isFamily = true

					items.push(family)

				}

			}.bind(this))

			items = this.$_.sortBy(items, function(item) {

				return item.sort.toLowerCase()

			})

			return items

		},

		contextTags: function() {

			return this.$_.where(this.$store.getters['data/tags/list'], {
				context: this.$CONSTANTS.SERVICE.VALUE[this.$store.getters['service/select/name']]
			})

		},

		can: function() {

			return this.$store.getters['service/select/can']

		},

		familyTags: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return tag.family === this.is.family

			}.bind(this))

		}

	},

	methods: {

		onTagAdd: function(tag) {

			this.$emit('add', tag)

		},

		onTagRemove: function(tag) {

			this.$emit('remove', tag)

		},

		onFamilyClick: function(id) {

			this.$nextTick(function() {
				
				this.is.family = id

			}.bind(this))

		},

		onCreateClick: function() {

			this.$store.dispatch('service/select/tags/create', {
				override: {
					game: [this.item.game.id],
					item: [this.item.id]
				}
			})

		},

		onTagsClick: function(e) {

			e.stopPropagation()

			this.$pubsub.$emit('open.modal', 'tagManage')

			this.$emit('close')

		},

		onTagToggle: function(tag) {

			this.is.loading = tag.id

			this.$store.dispatch('service/select/tags/toggle', {
				tag: tag,
				override: {
					item: this.item.id,
					game: this.item.game.id
				}
			}).then(function() {

				this.is.loading = false

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.is-desktop .family {
    background-color: rgba(0, 0, 0, 0.25);
}

.family >>> .type-divide {
    display: none;
}

.is-desktop .family >>> .dropdown-item-caret.is-back {
    left: 58px;
}

</style>